import { defineMessages } from "react-intl";

const messages = defineMessages({
  newRole: {
    id: "roles.newRole",
  },
});

export default messages;
